export enum Brand {
  STB = 'stb',
  COOP = 'coop',
  AKADEMIKERNE = 'akademikerne',
  DANSKE_BANK = 'danskeBank',
  HUSEIERNE = 'huseierne',
}

export type Union = AkaUnion | undefined;

export enum AkaUnion {
  AKA_AFAG = 'akaAfag',
  AKA_ECONA = 'akaEcona',
  AKA_LEGEFORENINGEN = 'akaLegeforeningen',
  AKA_NATURVITERNE = 'akaNaturviterne',
  AKA_NL = 'akaNl',
  AKA_PSYKOLOGIFORENINGEN = 'akaPsykologiforeningen',
  AKA_SAMFUNNSVITERNE = 'akaSamfunnsviterne',
  AKA_SAMFUNNSØKONOMENE = 'akaSamfunnsøkonomene',
  AKA_TANNLEGEFORENINGEN = 'akaTannlegeforeningen',
  AKA_VETERINÆRFORENINGEN = 'akaVeterinærforeningen',
}

export enum PartnerUrl {
  AKADEMIKERNE = 'mine-forsikringssider-akademikerne-pluss',
  COOP = 'mine-forsikringssider-coop',
  DANSKE_BANK = 'mine-forsikringssider-danske-bank',
  HUSEIERNE = 'mine-forsikringssider-huseierne',
  STB = 'mine-forsikringssider',
}
